import store from '../store';
import { quickDecrypt } from '../utils/crypto';

export const getAuthToken = () => {
  try {
    // 1. Try to get token from Redux store
    const state = store.getState();
    const reduxToken = state?.Login?.user?.token;

    if (isValidToken(reduxToken)) {
      return reduxToken;
    }

    // 2. Fallback to sessionStorage
    const sessionUser = sessionStorage.getItem('authUser');
    if (sessionUser) {
      try {
        const parsedUser = JSON.parse(sessionUser);
        const sessionToken = parsedUser?.token;
        if (isValidToken(sessionToken)) {
          return sessionToken;
        }
      } catch (parseError) {
        // Error parsing sessionStorage authUser
      }
    }

    // 3. Check for persisted Redux state
    const persistedRoot = sessionStorage.getItem('persist:root');
    if (persistedRoot) {
      try {
        const parsed = JSON.parse(persistedRoot);
        if (parsed.Login) {
          const loginState = quickDecrypt(parsed.Login);

          const persistedToken = loginState?.user?.token;
          if (isValidToken(persistedToken)) {
            return persistedToken;
          }
        }
      } catch (parseError) {
        // Error parsing persisted state
      }
    }

    // Token not found in any storage
    return null;
  } catch (error) {
    // Failed to get token
    return null;
  }
};

export const isAuthenticated = () => {
  const token = getAuthToken();
  return isValidToken(token);
};

// by msrusli, 05-Jun-2026: added JWT expiry validation
const isValidToken = token => {
  if (typeof token !== 'string' || token.trim().length === 0) return false;

  try {
    const parts = token.split('.');
    if (parts.length === 3) {
      const payload = JSON.parse(atob(parts[1]));
      if (payload.exp) {
        const expiryMs = payload.exp * 1000;
        return Date.now() < expiryMs;
      }
    }
    return true;
  } catch {
    return true;
  }
};
